import React from "react";
import Responsive from "react-responsive";
import style from "./Toolbar.module.scss";

const Desktop = (props) => <Responsive {...props} minWidth={1000} />;

const Counter = ({ total, filtered }) => (
  <Desktop>
    <h6 className={`h6 page-title ${style.totals}`}>Reports: {total}</h6>

    <div className="text-muted page-desc">{filtered} filtered</div>
  </Desktop>
);

export default Counter;
